<template>
  <div class="tw-relative tw-w-max">
    <Avatar :src="src" :alt="alt" :size="size" :shadow="shadow" />
    <IconButton
      color="outline-secondary"
      class="tw-absolute"
      :class="buttonPosition[size]"
      @click="openModal(EDIT_AVATAR_MODAL_NAME)"
      test_id="change-avatar-button"
    >
      <PenIcon />
    </IconButton>

    <FormModal header="Profile photo" :name="EDIT_AVATAR_MODAL_NAME">
      <EditableAvatar
        class="tw-p-6"
        :src="src"
        :alt="alt"
        :size="size"
        :is-set="isSet"
        @success="emit('success')"
      >
        <template
          #buttons="{
            isLoading,
            isAvatarSet,
            uploadNewImage,
            deleteExistingImage,
          }"
        >
          <div
            class="tw-mt-4 tw-flex tw-flex-col tw-items-center tw-justify-center tw-space-y-4 sm:tw-flex-row sm:tw-space-x-4 sm:tw-space-y-0"
          >
            <BaseButton
              color="outline-secondary"
              :is-disabled="isLoading"
              @click="uploadNewImage.activator"
              class="tw-w-56"
              test_id="upload-new-image-button"
            >
              <AddIcon class="tw-mr-2 tw-h-4 tw-w-4" />
              Upload new image
            </BaseButton>

            <BaseButton
              v-if="isAvatarSet"
              color="outline-red"
              :is-disabled="isLoading"
              @click="deleteExistingImage.activator"
              class="tw-w-56"
            >
              <BinIcon class="tw-mr-2 tw-h-4 tw-w-4" />
              {{
                deleteExistingImage.confirmationText || 'Delete existing avatar'
              }}
            </BaseButton>
          </div>
        </template>
      </EditableAvatar>
    </FormModal>
  </div>
</template>

<script setup>
import Avatar from '../avatar/Avatar.vue'
import IconButton from '../IconButton.vue'
import FormModal from './FormModal/FormModal.vue'
import EditableAvatar from '../avatar/EditableAvatar.vue'
import BaseButton from '../BaseButton.vue'
import AddIcon from '@/assets/images/icons/add.svg'
import BinIcon from '@/assets/images/icons/bin.svg'
import PenIcon from '@/assets/images/icons/pen.svg'
import { EDIT_AVATAR_MODAL_NAME } from '@/shared/data/globalVariables.js'
import { useModals } from '@/shared/composables/useModals.js'

const emit = defineEmits(['success'])

defineProps({
  src: {
    type: String,
    required: true,
  },
  alt: {
    type: String,
    required: true,
  },
  size: {
    type: String,
    default: 'md',
  },
  isSet: {
    type: Boolean,
    default: false,
  },
  shadow: {
    type: String,
    default: '',
  },
})

const { openModal } = useModals()

const buttonPosition = {
  '2xl': 'tw--right-0.5 tw--bottom-0.5',
  '3xl': 'tw-right-1 tw-bottom-1',
}
</script>
